import { networkService as network } from '@/services';

export const auditoriumsService = {
  getAuditoriums({ order = 'ASC', page = 1, take = 10, exhibitionHallId }) {
    return new Promise((resolve, reject) => {
      network
        .get(`/auditoriums/all?order=${order}&page=${page}&take=${take}&exhibitionHallId=${exhibitionHallId}`)
        .then((data) => {
          resolve(data.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAuditoriumIdx(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/auditoriums/${id}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
